import { css } from '@emotion/react'

export const cssTable = css`
  .handsontable .ht_master,
  .handsontable .htCore {
    padding-right: 0 !important;
  }
  .handsontable tr,
  .handsontable td {
    background-color: #ffffff !important;
    color: black !important;
    border-color: #e7e7e9 !important;
  }
  .handsontable.ht_clone_top_left_corner tr:first-child th:first-child,
  .handsontable.ht_clone_top tr:first-child th:first-child {
    border-radius: 4px 0 0 0;
    border-color: #e7e7e9 !important;
  }

  .handsontable.ht_clone_top th:last-child {
    border-radius: 0 4px 0 0;
    border-color: #e7e7e9 !important;
  }

  .handsontable th {
    text-align: left;
    border-color: #e7e7e9 !important;
  }

  .handsontable thead th {
    border-color: #e7e7e9 !important;
    background-color: #f7f7f9 !important;
  }

  .handsontable span.colHeader.columnSorting::before {
    display: none;
  }

  .handsontable span.colHeader.columnSorting::after {
    content: '▼';
    margin-left: 6px;
    font-size: 10px;
    color: #aaa;
    top: 65%;
    transform: translateY(-50%);
  }

  .handsontable span.colHeader.columnSorting.ascending::after {
    content: '▲';
    color: #333;
  }

  .handsontable span.colHeader.columnSorting.descending::after {
    content: '▼';
    color: #333;
  }
`
